import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ivecoDaily from "../../images/daily.png";
import "../../../src/product.css";

const IvecoDaily = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">IVECO DAILY</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={ivecoDaily}
              alt="IVECO Daily"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Daily cab chassis models allow the owner to fit the body that
              best suits their needs. The Daily cab chassis provides all the
              great benefits of the van, including large payload, superior
              strength, reliability and abundant driver comfort and safety
              features.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Diesel</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>3500 kg</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default IvecoDaily;